import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Dropzone from 'react-dropzone'

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';

import {
  startAddFile,
} from '../../../../store/actions/files';

const styles = theme => ({
  avatar: {
    marginRight: theme.spacing.unit*2,
  },
  card: {
    marginTop: theme.spacing.unit*3,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
  },
  rootContent: {
    backgroundColor: indigo[50],
  },
  title: {
    minWidth: '550px',
  },
});

class PhotoDialog extends Component {
  constructor(props) {
    super(props);
    const { file } = props;

    this.state = {
      file: {...file},
    }

  }

  handleChange (propertyName, value) {
    this.setState(function(prevState, props){
       return {
         file: {
           ...prevState.file,
           [propertyName]: value,
         }
       }
    });
  }

  //TODO: modify this so that it sets state for all items at once
  onDrop(acceptedFiles, rejectedFiles) {
    if (acceptedFiles.length > 0) {
      if (this.state.file.title === "") {
        this.handleChange("title", acceptedFiles[0].name);
      }
      this.handleChange("type", acceptedFiles[0].type);
      this.handleChange("fileData", acceptedFiles[0]);
    }
  }

  acceptedTypes() {
    return "image/jpeg, image/png, image/gif, image/svg+xml";
  }

  render() {
    const {
      classes,
      project,
      show,
      type,
      handleClose,
      startAddFile,
    } = this.props;
    const { file } = this.state;
    
    return (
      <div>
        <Dialog
          maxWidth="md"
          open={show}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <div className={classes.header}>
              <Avatar aria-label="Photo" className={classes.avatar}>
                F
              </Avatar>
              <div>
                <Typography variant="subheading">
                  {type === "edit" ? "Edit Photo" : "Add Photo"}
                </Typography>
              </div>
            </div>
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <div>
                  <TextField
                    className={classes.title}
                    id="title"
                    label="Title"
                    placeholder="Enter title"
                    margin="normal"
                    value={file.title}
                    onChange={ event => this.handleChange("title", event.target.value)}
                  />
                <Dropzone
                  accept={this.acceptedTypes()}
                  onDrop={this.onDrop.bind(this)}
                >
                    <p>Drop file here, or click to select file to upload.</p>
                  </Dropzone>
                </div>
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (type === "add") {
                  startAddFile(file)
                    .then(() => handleClose());

                } else {
                  const { id, ...updates } = file;
                  // startEditNote(id, updates)
                  //   .then(() => handleClose());
                }
              }}
              color="primary">
              {type === "add" ? "Add" : "Done"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}


const mapDispatchToProps = (dispatch) => ({
  startAddFile: (file) => dispatch(startAddFile(file)),
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(PhotoDialog)



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Dialog/PhotoDialog.jsx